import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'

import type { DeletePendingDiscountRequest, ExceptionalDiscountApplyRequest } from '@/dtos/exceptionalDiscount'
import { Apis } from '../appSettings/AppSettings'
import { discountEligibilityQueryKey } from './useDiscountEligibility'
import { policyVersionsQueryKey } from './usePolicyVersions'
import { useUrl } from '.'

export const useExceptionalDiscount = (insuranceId: number | undefined) => {
  const url = useUrl(Apis.exceptionalDiscount)
  const queryClient = useQueryClient()

  const invalidate = () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: policyVersionsQueryKey(insuranceId) }),
      queryClient.invalidateQueries({ queryKey: discountEligibilityQueryKey(insuranceId) }),
    ])

  const apply = useMutation({
    mutationFn: (request: ExceptionalDiscountApplyRequest) =>
      apiClient.post(`${url}/Apply`, request).then(r => r.data),
    onSuccess: invalidate,
  })

  const deletePending = useMutation({
    mutationFn: (request: DeletePendingDiscountRequest) =>
      apiClient.post(`${url}/DeletePending`, request).then(r => r.data),
    onSuccess: invalidate,
  })

  return { apply, deletePending }
}
